import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import { isEmpty } from "lodash";
import { getKeys } from "domain/keys/api/get-keys";
import { KeysRequestDto } from "domain/keys/entities/dtos/keys-request.dto";

export const getKeysAction = createAsyncThunk(
  "keys/getKeysAction",
  async ({ accountId }: KeysRequestDto) => {
    try {
      if (isEmpty(accountId)) {
        toast.error("Kindly first select an account from the drawer.");
        return;
      }

      return await getKeys({ accountId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
